import { inject, Injectable } from '@angular/core';
import type { ExportSseEventPayload } from '@api-types/sse/event-payloads/export.sse-event-payload';
import { SseEventType } from '@api-types/sse/sse.types';
import type { SseEventHandler } from '@core/sse/sse-event-handler';
import { ExportCenterService } from './export-center.service';

@Injectable({ providedIn: 'root' })
export class ExportSseHandler implements SseEventHandler<
  typeof SseEventType.Export
> {
  private readonly exportCenter = inject(ExportCenterService);

  readonly eventType = SseEventType.Export;

  handle(payload: ExportSseEventPayload): void {
    this.exportCenter.handleEvent(payload);
  }
}
